import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { convertCryptoToUsd } from 'shared/utils';
import { walletSelector } from '../store/wallet/selectors';

export const useUserBalance = () => {
  const balance = useSelector(walletSelector.balance);
  const exchangeRate = useSelector(walletSelector.exchangeRate);
  const balanceInUsd = useMemo(
    () => convertCryptoToUsd(balance, exchangeRate),
    [balance, exchangeRate]
  );

  return {
    balanceInCrypto: balance,
    balanceInUsd,
    exchangeRate,
  };
};
